import PropTypes from "prop-types";
import React from "react";
import TimelineActivity from "~/components/drawers/timeline/activity";
import { formatValue } from "./formatValue";
import HelpTip from "./HelpTip";

const display = (change, value) =>
  value == null || (Array.isArray(value) && !value.length)
    ? "Blank"
    : formatValue(change, value);

const CustomFieldsActivity = ({ activity, ...props }) => {
  const changes = activity.parameters?.changes || [];
  if (!changes.length) {
    return null;
  }
  return (
    <TimelineActivity
      {...props}
      activity={activity}
      title="Additional Details updated"
      icon="list-alt"
      prefix="far"
      editable={false}
      deletable={false}
      alwaysPublic
      content={
        <details className="my-2">
          <summary>View changes</summary>
          <dl className="mt-2 mb-0">
            {changes.map((change) => (
              <div
                key={change.definition_id}
                className="mb-3"
                style={{ overflowWrap: "anywhere", whiteSpace: "pre-wrap" }}
              >
                <dt>
                  {change.label}
                  {change.help_text && (
                    <HelpTip label={change.label}>{change.help_text}</HelpTip>
                  )}
                </dt>
                <dd>
                  <span className="text-muted">Before: </span>
                  {display(change, change.before)}
                  <br />
                  <span className="text-muted">After: </span>
                  {display(change, change.after)}
                </dd>
              </div>
            ))}
          </dl>
        </details>
      }
    />
  );
};
CustomFieldsActivity.propTypes = { activity: PropTypes.object.isRequired };
export default CustomFieldsActivity;
